import isBoolean from 'lodash/isBoolean';
import isNumber from 'lodash/isNumber';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';

/**
 * Used as eventKey to make all panels expand when
 * the Expand All button is clicked. Outside of the
 * Expand All mode, all Panel components have non-negative
 * integers as keys.
 * By setting EXPAND_ALL_PANEL_EVENT_KEY to -1,
 * we disable single panels from expanding individually.
 */
export const EXPAND_ALL_PANEL_EVENT_KEY = -1;

/**
 * Use this function to make boolean values pretty (Yes, No). If value not boolean, there is no
 * transformation
 *
 * @param {*} value
 * @returns [Yes, No] instead of [true, false] if the value is a boolean. Else returns the value arg
 */
export function valueCleaner(
  value: unknown,
  valueMap?: Record<string, unknown>
): unknown {
  if (valueMap && isString(value)) {
    const mappedValue = valueMap[value];
    if (mappedValue) {
      return mappedValue;
    }
  }
  if (isBoolean(value)) return value ? 'Yes' : 'No';
  if (isNumber(value)) return value; // Always render numbers or else "0" will evaluate to false-y
  return value ?? '';
}

export function isNotNil(e: unknown): boolean {
  return !isNil(e);
}
